import { AxiosResponse } from 'axios';
import http from 'services/http';
import { Breed, Bull, BullSummary } from 'types';

export type GetAllResponse = {
  bulls: Bull[],
  breedsProofs: Breed[]
}

export type GetSummaryResponse = {
  version: number,
  bulls: BullSummary[],
  breedsProofs?: Breed[],
  stamps?: string[]
}

const getAll = async () => http.get<any, AxiosResponse<GetAllResponse>>('/bull/find');

const getSummaries = async () =>
  http.get<any, AxiosResponse<GetSummaryResponse>>('/bull/find/summary', {
    params: { summaryShape: 'evaluations-indices-v2' }
  });

const findByCrvCodes = async (CRVcodes: string[]) => {
  const params = { CRVcodes };

  return http.get<any, AxiosResponse<GetAllResponse>>('/bull/find', { params });
};

const bullDetailsCache = new Map<string, Promise<Bull>>();

const getByCrvCode = async (CRVcode: string) => {
  const cached = bullDetailsCache.get(CRVcode);
  if (cached) return cached;

  const detailRequest = http.get<any, AxiosResponse<Bull | { bull: Bull }>>(
    `/bull/find/${encodeURIComponent(CRVcode)}`
  ).then(({ data }) => 'bull' in data ? data.bull : data);
  bullDetailsCache.set(CRVcode, detailRequest);

  return detailRequest;
};

const bulls = {
  getAll,
  getSummaries,
  getByCrvCode,
  findByCrvCodes,
};

export default bulls;
